module.exports = __webpack_public_path__ + "img/mz_03.2ca28bcf.png";